import React, {Component} from 'react';
import { PLANNER_STORAGE_KEY } from "./utils/constants";
import { BASKET_DECREASED, BASKET_INCREASED } from "./utils/events";

class HeaderBasketIcon extends Component {

    state = {
        count: 0,
    }

    componentDidMount() {
        const addedPanels = JSON.parse(localStorage.getItem(PLANNER_STORAGE_KEY)) || []
        this.setState({ count: addedPanels.length })

        document.addEventListener(BASKET_INCREASED, () => {
            let { count } = this.state;
            this.setState({ count: ++count });
        })

        document.addEventListener(BASKET_DECREASED, () => {
            let { count } = this.state;
            this.setState({ count: --count });
        })
    }

    render() {
        if (!this.state.count) return null;

        return (
            <span className="header__controls-number">{this.state.count}</span>
        )
    }

    handleClose() {
        this.setState({
            active: false,
            panel: null,
        })
    }
}

export default HeaderBasketIcon;
